const seoData = {
  "/": {
    title: "Custom Software & AI Solutions for Businesses | YperSystem Solutions",
    description:
      "YperSystem Solutions provides custom software, AI, ERP, web, cloud, mobile and digital solutions designed to help businesses improve efficiency, automate processes and achieve sustainable growth."
  },

  "/aboutus": {
    title: "About YperSystem Solutions | Technology & Software Solutions",
    description:
      "Learn about YperSystem Solutions and our approach to building practical software, AI and digital solutions that help businesses improve efficiency and achieve sustainable growth."
  },

  "/contactus": {
    title: "Contact YperSystem Solutions | Software & AI Solutions",
    description:
      "Contact YperSystem Solutions to discuss custom software, AI, ERP, web, cloud, mobile and digital solutions for your business."
  },

  "/services": {
    title: "Software & Digital Services | YperSystem Solutions",
    description:
      "Explore software development, ERP, web, cloud, mobile, database, digital marketing and other technology services designed around your business needs."
  },

  "/howwework": {
    title: "How We Work | Software Development Process | YperSystem Solutions",
    description:
      "Discover how YperSystem Solutions turns business ideas into reliable software solutions through requirement analysis, planning, development, testing, deployment and support."
  },

  "/ai-solutions": {
    title: "AI Solutions for Businesses | YperSystem Solutions",
    description:
      "Explore practical AI solutions for creativity, automation and business operations, including AI video, image generation and custom AI business solutions."
  },

  // ================= SERVICES =================

  "/services/custom-software": {
    title: "Custom Software Development | YperSystem Solutions",
    description:
      "Build custom software solutions tailored to your business needs. We develop scalable, secure and user-friendly software designed to improve efficiency and support business growth."
  },

  "/services/erp-business": {
    title: "ERP & Business Management Solutions | YperSystem Solutions",
    description:
      "Streamline inventory, sales, purchases, accounting, customers and daily operations with ERP and business management software tailored to your business."
  },

  "/services/web-application": {
    title: "Web Application Development | YperSystem Solutions",
    description:
      "Build modern, secure and responsive web applications designed around your business goals, workflows and customer needs."
  },

  "/services/website-development": {
    title: "Website Development Services | YperSystem Solutions",
    description:
      "Get professional, responsive and secure websites built around your business requirements using modern web technologies."
  },

  "/services/windows-application": {
    title: "Windows Application Development | YperSystem Solutions",
    description:
      "Custom Windows applications designed to simplify business operations, improve productivity and support your specific business requirements."
  },

  "/services/mobile-application": {
    title: "Mobile App Development | YperSystem Solutions",
    description:
      "Build custom mobile applications that provide convenient access to your services, products and business operations."
  },

  "/services/frontend-development": {
    title: "Frontend Development Services | YperSystem Solutions",
    description:
      "Modern and responsive frontend development using React, Angular and other technologies to create engaging and user-friendly applications."
  },

  "/services/database-solutions": {
    title: "Database Solutions & Development | YperSystem Solutions",
    description:
      "Reliable database design, development and management using SQL, MongoDB and modern technologies for secure and scalable applications."
  },

  "/services/cloud-solutions": {
    title: "Cloud Solutions for Businesses | YperSystem Solutions",
    description:
      "Scalable cloud solutions that provide accessibility, flexibility and reliable performance while supporting your growing business needs."
  },

  "/services/software-maintenance": {
    title: "Software Maintenance & Support | YperSystem Solutions",
    description:
      "Keep your software reliable and up to date with continuous monitoring, maintenance, improvements, technical support and performance optimization."
  },

  "/services/digital-marketing": {
    title: "Digital Marketing & SEO Services | YperSystem Solutions",
    description:
      "Improve your online visibility and reach potential customers with SEO, social media and digital marketing solutions designed to support business growth."
  },

  "/services/domain-hosting": {
    title: "Domain & Hosting Services | YperSystem Solutions",
    description:
      "Reliable domain registration and hosting solutions to help businesses establish and maintain a professional online presence."
  },

  // ================= INDUSTRIES =================

  "/industries": {
    title: "Technology Solutions for Different Industries | YperSystem Solutions",
    description:
      "Explore technology and software solutions designed for manufacturing, retail, healthcare, education, finance, logistics, hospitality and professional services."
  },

  "/industries/education": {
    title: "Education Technology Solutions | YperSystem Solutions",
    description:
      "Technology and software solutions designed to support educational organizations, improve operations and deliver better digital experiences."
  },

  "/industries/finance": {
    title: "Finance & Accounting Software Solutions | YperSystem Solutions",
    description:
      "Technology solutions designed to support finance and accounting operations with reliable, secure and efficient software."
  },

  "/industries/healthcare": {
    title: "Healthcare Technology Solutions | YperSystem Solutions",
    description:
      "Digital and software solutions designed to help healthcare organizations improve operations, efficiency and technology-driven services."
  },

  "/industries/hospitality": {
    title: "Hospitality Technology Solutions | YperSystem Solutions",
    description:
      "Technology solutions designed to help hospitality businesses improve operations, customer experiences and business efficiency."
  },

  "/industries/logistics": {
    title: "Logistics & Transportation Software Solutions | YperSystem Solutions",
    description:
      "Software and technology solutions designed to improve logistics, transportation operations, efficiency and business management."
  },

  "/industries/manufacturing": {
    title: "Manufacturing Software Solutions | YperSystem Solutions",
    description:
      "Technology and software solutions designed to help manufacturing businesses improve operations, productivity and business efficiency."
  },

  "/industries/professional": {
    title: "Professional Services Technology Solutions | YperSystem Solutions",
    description:
      "Digital and software solutions designed for professional service businesses to improve productivity, operations and customer experiences."
  },

  "/industries/realestate": {
    title: "Real Estate Technology Solutions | YperSystem Solutions",
    description:
      "Software and digital solutions designed to help real estate businesses manage operations, improve efficiency and deliver better customer experiences."
  },

  "/industries/retailecommerce": {
    title: "Retail & E-Commerce Technology Solutions | YperSystem Solutions",
    description:
      "Technology solutions for retail and e-commerce businesses designed to improve operations, customer experiences and digital growth."
  },

  "/industries/startups": {
    title: "Technology Solutions for Startups & Small Businesses | YperSystem Solutions",
    description:
      "Practical software and digital solutions designed to help startups and small businesses improve operations, efficiency and growth."
  },

  // ================= AI =================

  "/ai/video-creator": {
    title: "AI Video Creator & Editor | YperSystem Solutions",
    description:
      "Create engaging videos with AI-powered generation and editing. Turn ideas, scripts and images into professional videos quickly and efficiently."
  },

  "/ai/image-creator": {
    title: "AI Image Creator | YperSystem Solutions",
    description:
      "Generate marketing creatives, product images and custom visuals using AI-powered image generation and editing solutions."
  },

  "/ai/business-solutions": {
    title: "AI Business Solutions | YperSystem Solutions",
    description:
      "Use AI to automate repetitive tasks, improve productivity, process documents and create smarter customer experiences with practical business solutions."
  }
};

export default seoData;